import type { PersonalPageItemLabels } from '../labels';
import type { PersonalPageItemOptions } from './types';

export const noItems: PersonalPageItemOptions = {
  inventory: false,
  payments: false,
  paymentsRequired: false,
  coupon: false,
  perBuyerLimit: false,
  recurringOnItem: false,
  singular: false
};

export const donationUnitPayments: PersonalPageItemOptions = {
  inventory: false,
  payments: true,
  paymentsRequired: true,
  coupon: false,
  perBuyerLimit: false,
  recurringOnItem: true,
  singular: false
};

export const donationUnitInventory: PersonalPageItemOptions = {
  inventory: true,
  payments: true,
  paymentsRequired: true,
  coupon: false,
  perBuyerLimit: true,
  recurringOnItem: true,
  singular: false
};

export const ticketOptions: PersonalPageItemOptions = {
  inventory: true,
  payments: true,
  paymentsRequired: true,
  coupon: true,
  perBuyerLimit: true,
  recurringOnItem: false,
  singular: false
};

export const registrantOptions: PersonalPageItemOptions = {
  inventory: true,
  payments: false,
  paymentsRequired: false,
  coupon: false,
  perBuyerLimit: true,
  recurringOnItem: false,
  singular: false
};

export const serviceOptions: PersonalPageItemOptions = {
  inventory: true,
  payments: true,
  paymentsRequired: false,
  coupon: true,
  perBuyerLimit: true,
  recurringOnItem: false,
  singular: true
};

export const donationUnitLabels: PersonalPageItemLabels = {
  singular: 'יחידת תרומה',
  plural: 'יחידות תרומה',
  gender: 'female'
};
export const ticketLabels: PersonalPageItemLabels = { singular: 'כרטיס', plural: 'כרטיסים', gender: 'male' };
export const registrantLabels: PersonalPageItemLabels = { singular: 'נרשם', plural: 'נרשמים', gender: 'male' };
export const serviceLabels: PersonalPageItemLabels = { singular: 'שירות', plural: 'שירותים', gender: 'male' };
export const emptyLabels: PersonalPageItemLabels = { singular: '', plural: '', gender: 'male' };
